// extracted by mini-css-extract-plugin
module.exports = {"container":"SquareCheckbox_container__37V_Z","input":"SquareCheckbox_input__2c3Ov","label":"SquareCheckbox_label__16Md3 text_text-2__18Lnm"};